'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormComponent = require('./FormComponent');

var _FormComponent2 = _interopRequireDefault(_FormComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FormComponent2.default;